import $ from "jquery";
let Banner;

let noun_user;
let url_to_array;

noun_user = require("../helpers/noun_user").default;

url_to_array = require("../helpers/url_to_array").default;

Banner = (() => {
    function Banner() {
        let $banners;
        $banners = $(".banner");
        if (noun_user && noun_user.is_anonymous === false) {
            $("document").ready(() => $banners.removeClass("dismissed"));
            $(".dismiss-banner").on("click", function(e) {
                let $banner;
                let callback;
                e.preventDefault();
                $banner = $(this).parents(".banner");

                if ($("body.avatar-settings-page")) {
                    $banner.addClass("avatar-change-message-dismissed");
                }

                callback = $banner.data("callback");
                $banner.slideUp();
                if (typeof callback === "string") {
                    return $.get(`//${url_to_array[2]}/${callback}`, data => {
                        console.log("cleared banner");
                    });
                }
            });
        }
    }

    return Banner;
})();

export default Banner();
